import { AppConst } from 'constants/appConst';
import { DivConst } from 'constants/divConst';
import { AppHelper } from 'helpers/appHelper';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
import WsModalCreateContent from './component/modal/WsModalCreateContent';
import WsIndexContentsPublished from './component/pages/index/WsIndexContentsPublished';
import WsIndexContentsUnpublished from './component/pages/index/WsIndexContentsUnpublished';
import WsIndexUsage from './component/pages/index/WsIndexUsage';

/**
 *　ホーム画面
 */
export default function WsIndex(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);
  const [modalCreateContentOpenState, setModalCreateContentOpenState] = useState(false);
  const isExpiredPlan =
    acctState.company.plan.planTypeDiv === DivConst.items.planType.expiredTrial.value ||
    acctState.company.plan.planTypeDiv === DivConst.items.planType.expiredBasic.value;
  const isTrial = acctState.company.plan.planTypeDiv === DivConst.items.planType.trial.value;
  const navigate = useNavigate();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    if (acctState.proxyLogin && acctState.user?.companies.length === 0) {
      navigate('/404');
    }
  }, [acctState.proxyLogin, acctState.user?.companies, navigate]);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * コンテンツ作成モーダルを開く
   */
  const onModalCreateContentOpen = () => {
    setModalCreateContentOpenState(true);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-header">
        {isTrial && (
          <>
            <div className="container">
              <div className="card-white card-body mb-3 p-3">
                <div className="d-block mb-2 lh-lg">
                  トライアルプラン利用中です。 利用期限：
                  {AppHelper.formatTimeToDate(
                    acctState.company.plan.trialEndedAt,
                    'yyyy/MM/dd HH:mm'
                  )}
                </div>
                <div className="d-block lh-lg">
                  <a href={AppConst.url.upgrade} className="btn btn-progress mx-auto me-1">
                    お問い合わせフォーム
                  </a>
                  <span className="my-0">
                    よりベーシックプランへの変更を行うことで全機能をご利用いただけます。
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        {isExpiredPlan && (
          <>
            <div className="container">
              <div className="card-white card-body mb-3 p-3 text-bg-danger">
                <div className="d-block mb-2 lh-lg">
                  プランの利用期間が終了したため一部機能が制限されています。
                </div>
                <div className="d-block lh-lg">
                  <a href={AppConst.url.upgrade} className="btn btn-progress mx-auto me-1">
                    お問い合わせフォーム
                  </a>
                  <span className="my-0">
                    よりベーシックプランへの変更を行うことで全機能をご利用いただけます。
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">こんにちは、{acctState.user.name}さん</h2>
            </div>
            <div className="flex-grow-1 flex-right">
              <ul className="list-inline list-btn mb-0">
                <li className="list-inline-item mw-238">
                  <a
                    onClick={onModalCreateContentOpen}
                    className="btn btn-common btn-common-w238 outline-blue"
                  >
                    + 新しいコンテンツを作成する
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 利用状況 */}
      <WsIndexUsage />
      {/* 直近のコンテンツレポート */}
      <WsIndexContentsPublished />

      <section className="section-topics">
        <div className="container">
          <div className="row row-15-xl">
            {/* 作成中のコンテンツ */}
            <WsIndexContentsUnpublished />
            {/* ヘルプ&トピックス */}
            {/* <WsIndexHelpAndTopics /> */}
          </div>
        </div>
      </section>
      {/* コンテンツ作成モーダル */}
      <WsModalCreateContent
        open={modalCreateContentOpenState}
        setOpen={setModalCreateContentOpenState}
      />
    </>
  );
}
